<template>
	<div class="page-wrapper">
		<div class="container">
	      <div class="row nav-container">
	        <ul>
	          <li><a href="#/admin/home/">메인</a></li>
            <li><a href="#/admin/checkin/">체크인</a></li>
	          <li><a href="#/admin/settings/">세팅</a></li>
	          <li><a href="#/admin/customers/">업체</a></li>
	          <li><a class="active" href="#/admin/forwarders/">파트너</a></li>
	          <li><a href="#/admin/users/">사용자</a></li>
	          <li><div class="logout" v-on:click="logout">로그아웃</div></li>
	        </ul>
	      </div>
	    </div>
	    <div class="container">
	    	<h4>Customer List <div  v-show="editForwarder == false" class="btn btn-primary" v-on:click="openNewForwarderForm()">Add</div></h4>
	    	<table class="table">
	    		<tr>
	    			<th>title</th>
	    			<th>택배사</th>
	    			<th>송장</th>
	    			<th>전화번호</th>
	    			<th>FAX</th>
	    			<th>주소</th>
	    			<th></th>
	    		</tr>
	    		<tr v-for="(item, index) in forwarders">
	    			<td>{{item.title}}</td>
	    			<td>{{item.delivery_company}}</td>
	    			<td>{{item.number_min}}-{{item.number_max}}</td>
	    			<td>{{item.telephone}}</td>
	    			<td>{{item.fax}}</td>
	    			<td>{{item.address_1}} {{item.address_2}} {{item.address_3}} {{item.post_code}}</td>
	    			<td><button v-show="editForwarder == false" type="button" class="btn btn-primary" v-on:click="editForwarderForm(index)">Edit</button></td>

	    		</tr>
	    	</table>
	    </div>
	    <div class="new-item-form" v-if="editForwarder != false">
		   	<div class="container">
		   		<div class="row">
		   			<div class="col-12">
			   			<h4 v-if="editForwarder.id == 0">신규등록</h4>
			   			<h4 v-if="editForwarder.id > 0">수정 [{{editForwarder.title}}]</h4>
		   			</div>
		   		</div>
		   		<div class="form-group row">
		   			<div class="col-2">Title</div>
		   			<div class="col-2"><input type="text" class="form-control" v-model="editForwarder.title" placeholder="Title"/></div>
		   		</div>
		   		<div class="form-group row">
		   			<div class="col-2">이메일</div>
		   			<div class="col-2"><input type="text" class="form-control" v-model="editForwarder.email" placeholder="이메일"/></div>
		   		</div>
		   		<div class="form-group row">
		   			<div class="col-2">전화번호</div>
		   			<div class="col-2"><input type="text" class="form-control" v-model="editForwarder.telephone" placeholder="전화번호"/></div>
		   		</div>
		   		<div class="form-group row">
		   			<div class="col-2">FAX 번호</div>
		   			<div class="col-2"><input type="text" class="form-control" v-model="editForwarder.fax" placeholder="FAX 번호"/></div>
		   		</div>
		   		<div class="form-group row">
		   			<div class="col-2">우편번호</div>
		   			<div class="col-2"><input type="text" class="form-control" v-model="editForwarder.post_code" placeholder="우편번호"/></div>
		   		</div>
		   		<div class="form-group row">
		   			<div class="col-2">주소</div>
		   			<div class="col-4"><input type="text" class="form-control" v-model="editForwarder.address_1" placeholder="주소"/></div>
		   		</div>
		   		<div class="form-group row">
		   			<div class="col-2">주소2</div>
		   			<div class="col-4"><input type="text" class="form-control" v-model="editForwarder.address_2" placeholder="주소 2"/></div>
		   		</div>
		   		<div class="form-group row">
		   			<div class="col-2">주소3</div>
		   			<div class="col-4"><input type="text" class="form-control" v-model="editForwarder.address_3" placeholder="주소 3"/></div>
		   		</div>
		   		<div class="form-group row">
		   			<div class="col-2">택배사</div>
		   			<div class="col-2">
		   				<select v-model="editForwarder.delivery_company">
		   					<option value="우체국">우체국</option>
		   					<option value="SLX">SLX</option>
		   					<option value="CJ">CJ</option>
		   				</select>
		   			</div>
		   			<div class="col-2">송장번호</div>
		   			<div class="col-2"><input type="text" class="form-control" v-model="editForwarder.number_min" placeholder="시작번호"/></div>
		   			<div class="col-1"> - </div>
		   			<div class="col-2"><input type="text" class="form-control" v-model="editForwarder.number_max" placeholder="마지막번호"/></div>
		   		</div>
		   	</div>
		   	<div class="row">
	          <div class="col-6">
	            <div class="btn btn-secondary" v-on:click="closeEditItemForm()">Close</div>
	          </div>
	          <div class="col-6">
	            <div v-if="editForwarder.id == 0" class="btn btn-primary" v-on:click="submitEditItem()">CREATE</div>
	            <div v-if="editForwarder.id > 0" class="btn btn-primary" v-on:click="submitEditItem()">UPDATE</div>
	          </div>
	        </div>
		</div>
	   	<v-dialog/>
	</div>
</template>
<script>
require('@/assets/css/styles.css')

import Router from '../router';
import VModal from '../router';
import axios from 'axios';
export default {
	name: 'CustomerManagement',

	data () {
		return {
			msg: 'Admin Customers',
			user:false,
			forwarders:[],
			editForwarder:false,
		}
	},
	created: function() {
      if(localStorage.getItem('id') == undefined || localStorage.getItem('id') == null || localStorage.getItem('id') === '') {
          Router.push('/admin');
          return;
      }
      this.$data.user = {
          "id": localStorage.getItem('id'),
      }
      this.getForwarders();

	},
	mounted: function(){

	},
	methods: {
		logout: function() {
	      var self = this;
	      this.$modal.show('dialog', {
	            //title: '로그아웃',
	            text: '로그아웃 하시겠습니까?',
	            buttons:[
	              {
	                title:'아니요',
	                handler:()=>{
	                  self.$modal.hide('dialog');

	                }
	              },
	              {
	                title:'로그아웃',
	                handler:()=>{
	                  self.$modal.hide('dialog');
	                  self.onLogoutConfirmed();
	                }
	              },

	            ]

	      });
	    },
	    onLogoutConfirmed: function() {
	      localStorage.removeItem('id');
	      localStorage.removeItem('email');
	      localStorage.removeItem('level');
	      localStorage.removeItem('admin');
	      localStorage.removeItem('password');
	      Router.push('/admin');
	    },
		showModal: function(title, message) {
	  		console.log("show modal " + title  + " : " + message);
	  		this.$modal.show('dialog',{
						title: title,
						text: message,
						buttons:[
							{title:'Close'}
						]
					})
					return;
	  	},
	  	getForwarders: function() {
			var self = this;
	  		var url = process.env.APP_URL + 'api/get_forwarders.php?id=' + this.$data.user.id;
	     	axios.get(url)
	        .then(response=>{
	        	console.log("Get Pending");
	        	console.log(response);

	        	var data = response.data;
	        	if(data.success== true) {
	        		self.$data.forwarders = data.items;
	        	} else {

	        	}
	        })
	        .catch(error=>{

	        });
		},
		editForwarderForm: function(index) {
			this.$data.editForwarder = this.$data.forwarders[index];
		},
		openNewForwarderForm: function() {
			this.$data.editForwarder = {
				id:0,
				title:'',
				description:'',
				delivery_company:'',
				number_min:'',
				number_max:'',
				post_code:'',
				address_1:'',
				address_2:'',
				address_3:'',
				telephone:'',
				fax:'',
				email:'',
			};
		},
		closeEditItemForm: function() {
			this.$data.editForwarder = false;
		},
		submitEditItem: function() {
			console.log("submit edit item");
			if(this.$data.editForwarder == false) {
				return;
			}
			if(this.$data.editForwarder.title.length == 0) {
				this.showModal("ERROR", "회사명을 입력하세요");
				return;
			}
			if(this.$data.editForwarder.delivery_company == 'Select') {
				this.showModal("ERROR", "배송회사를 선택하세요");
				return;
			}
			if(this.$data.editForwarder.number_min.length == 0) {
				this.showModal("ERROR", "시작 송장번호를 입력하세요");
				return;
			}
			if(this.$data.editForwarder.number_max.length == 0) {
				this.showModal("ERROR", "마지막 송장번호를 입력하세요");
				return;
			}
			if(this.$data.editForwarder.post_code.length == 0) {
				this.showModal("ERROR", "우편번호를 입력하세요");
				return;
			}
			if(this.$data.editForwarder.address_1.length == 0) {
				this.showModal("ERROR", "주소를 입력하세요");
				return;
			}
			if(this.$data.editForwarder.address_2.length == 0) {
				this.showModal("ERROR", "주소를 입력하세요");
				return;
			}
			if(this.$data.editForwarder.address_3.length == 0) {
				this.showModal("ERROR", "주소를 입력하세요");
				return;
			}
			if(this.$data.editForwarder.telephone.length == 0) {
				this.showModal("ERROR", "전화번호를 입력하세요");
				return;
			}
			if(this.$data.editForwarder.fax.length == 0) {
				this.showModal("ERROR", "FAX번호를 입력하세요");
				return;
			}
			if(this.$data.editForwarder.email.length == 0) {
				this.showModal("ERROR", "이메일 입력하세요");
				return;
			}
			console.log("submit edit item");
			var data = {
				"title": this.$data.editForwarder.title,
				"delivery_company": this.$data.editForwarder.delivery_company,
				"number_min":this.$data.editForwarder.number_min,
				"number_max":this.$data.editForwarder.number_max,
				"post_code":this.$data.editForwarder.post_code,
				"address_1":this.$data.editForwarder.address_1,
				"address_2":this.$data.editForwarder.address_2,
				"address_3":this.$data.editForwarder.address_3,
				"telephone":this.$data.editForwarder.telephone,
				"fax": this.$data.editForwarder.fax,
				"email": this.$data.editForwarder.email
			}
			if(this.$data.editForwarder.id > 0) {
				data["id"] = this.$data.editForwarder.id;
				var postData = {
					"table": "shipping_company_table",
					"data": data
				};
				var self = this;
				axios.post(process.env.APP_URL + 'api/update.php', postData)
				.then(response=>{
					console.log(response);
					var data = response.data;
					if(data.success == true) {
						console.log("Successful update");
						for(var i = 0 ; i < self.$data.forwarders.length ; i++) {
							if(self.$data.forwarders[i].id == data.item.id) {
								self.$data.forwarders[i] = data.item;
								break;
							}
						}
						console.log("Set newITem to false");
						self.$data.editForwarder = false;
					} else {
						self.showModal("ERROR", "Failed to update " + data.message);
					}
				})
				.catch(error=>{

				})
			} else {
				var self = this;
				axios.post(process.env.APP_URL + 'api/create_forwarder.php', data)
				.then(response=>{
					console.log(response);
					var data = response.data;
					if(data.success == true) {
						console.log("Successful update");
						self.$data.forwarders.push(data.item);

						console.log("Set newITem to false");
						self.$data.editForwarder = false;
					} else {
						self.showModal("ERROR", "Failed to update " + data.message);
					}
				})
				.catch(error=>{

				})
			}
		},
		logout: function() {
	      var self = this;
	      this.$modal.show('dialog', {
	            //title: '로그아웃',
	            text: '로그아웃 하시겠습니까?',
	            buttons:[
	              {
	                title:'아니요',
	                handler:()=>{
	                  self.$modal.hide('dialog');

	                }
	              },
	              {
	                title:'로그아웃',
	                handler:()=>{
	                  self.$modal.hide('dialog');
	                  self.onLogoutConfirmed();
	                }
	              },

	            ]

	      });
	    },
	    onLogoutConfirmed: function() {
	      localStorage.removeItem('id');
	      localStorage.removeItem('email');
	      localStorage.removeItem('level');
	      localStorage.removeItem('admin');
	      localStorage.removeItem('password');
	      Router.push('/admin');
	    },
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Forwarders.vue